export default __webpack_public_path__ + "static/media/Bonnie 9781408355220.5b668dd9.jpg";